<template>
  <!--通用表格弹窗-->
  <local-dialog
    :title="title"
    :visible="visible"
    :show-close="true"
    :fullscreen="false"
    :append-to-body="appendToBody"
    :width="width"
    :height="height"
    :auto-zoom="true"
    @close="handleClose"
  >
    <template slot="content">
      <div v-if="$slots.default" class="mb-10">
        <slot />
      </div>
      <el-input
        v-if="showSearch"
        ref="searchInput"
        v-model="filterText"
        class="mb-10"
        clearable
        :placeholder="placeholder"
        size="mini"
        @keyup.native.stop.enter="queryTableList('search')"
        @clear="queryTableList('search')"
      >
        <i
          slot="suffix"
          class="el-input__icon el-icon-search pointer"
          @click="queryTableList('search')"
        />
      </el-input>
      <ag-grid-wrap>
        <ag-grid-vue
          ref="agGrid"
          class="ag-theme-balham grid-class"
          :row-drag-managed="true"
          :grid-options="gridOptions"
          :row-data="rowData"
          :column-defs="gridColumnDefs"
          :modules="modules"
          @selection-changed="onSelectionChangedRightData"
        />
        <local-pagination
          v-if="showPagination"
          ref="pagination"
          :total="pagination.total"
          :page="pagination[pageKey]"
          :limit="pagination[pageSizeKey]"
          :event="pageChange"
        />
      </ag-grid-wrap>
    </template>
    <div v-if="!onlyShow" slot="footer">
      <el-button size="mini" plain @click="handleClose">{{
        $t('btns.cancel')
      }}</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">{{
        $t('btns.confirmKey')
      }}</el-button>
    </div>
  </local-dialog>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { AllModules } from 'ag-grid-enterprise'
import { request, MessageUtil, Format } from '@cndinfo/cube-web-utils'
import AutoWrap from '../../AutoWrap/index.js'
import localDialog from '../../Dialog/index.js'
import localPagination from '../../Pagination/index.js'
export default {
  name: 'DialogTable',
  components: {
    AgGridVue,
    AutoWrap,
    localDialog,
    localPagination
  },
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 宽度
    width: {
      type: String,
      default: '740px'
    },
    // 高度
    height: {
      type: [String, Number],
      default: ''
    },
    // 弹窗显隐
    visible: {
      type: Boolean,
      default: false
    },
    // 是否单选
    radio: {
      type: Boolean,
      default: true
    },
    // 搜索框提示文字
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    // 是否展示搜索框
    showSearch: {
      type: Boolean,
      default: false
    },
    // 是否需要分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 是否展示确定/取消
    onlyShow: {
      type: Boolean,
      default: false
    },
    // 禁用选择的key值
    disableSelectKey: {
      type: String,
      default: ''
    },
    // 禁用选择的数组
    disableSelected: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 接口调用成功的回调函数
    afterFetch: {
      type: Function,
      default: () => {}
    },
    // 不知道干嘛
    selectChange: {
      type: Function,
      default: () => {}
    },
    // 不知道干嘛
    customSelect: {
      type: Boolean,
      default: false
    },
    // AG 表头
    columnDefs: {
      type: Array,
      required: true,
      default: () => {
        return [
          { field: 'test1', headerName: '表头1', width: 100 },
          { field: 'test2', headerName: '表头2', width: 100 }
        ]
      }
    },
    // agGrid表格显示全选按钮
    selectAll: {
      type: Boolean,
      default: true
    },
    // 其他请求参数
    otherParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 接口参数
    reqConfig: {
      type: Object,
      default: () => {
        return {
          url: '', // 接口api
          method: '', // 请求方法
          params: {}, // 请求参数
          keyword: '', // 查询关键字
          searchValue: '', // 搜索框默认值设置
          dataFormat: {}, // 数据格式
          updataUrl: false // 更新分页信息到路径上
        }
      }
    },
    // 是否双击选中
    suppressRowClickSelection: {
      type: Boolean,
      default: true
    },
    pageKey: {
      type: String,
      default: 'pageNo'
    },
    pageSizeKey: {
      type: String,
      default: 'pageSize'
    },
    showDisabledCheckboxes: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modules: AllModules,
      gridColumnDefs: [],
      // grid
      gridOptions: {},
      rowData: [],
      selectedRightDataNodes: [],
      // 分页配置
      tempInitparams: {},
      pagination: {
        pageNo: 0,
        pageSize: 10,
        total: 0
      },
      filterText: '',
      // ag-grid【列】默认配置
      defColumnDefs: [
        {
          field: 'index',
          headerName: '',
          maxWidth: 40,
          minWidth: 40,
          checkboxSelection: true,
          showDisabledCheckboxes: this.showDisabledCheckboxes,
          headerCheckboxSelection: !this.radio,
          cellStyle: { 'justify-content': 'Center', textAlign: 'center' },
          cellClass: 'grid-cell-centered',
          cellRenderer: (params) => {
            let isDisable = false
            if (this.disableSelected && this.disableSelected.length) {
              this.disableSelected.map((item) => {
                if (item === params.data[this.disableSelectKey]) {
                  isDisable = true
                }
              })
            }
            if (this.disableSelectKey && isDisable) {
              params.eGridCell.children[0].children[0].style.setProperty(
                'display',
                'flex',
                'important'
              )
              params.eGridCell.children[0].children[0].children[0].children[1].style.background =
                '#e4e4e4'
            }
          }
        }
      ]
    }
  },
  computed: {
    // 接口地址
    url() {
      return this.reqConfig.url
    },
    //
    updataUrl() {
      return this.reqConfig.updataUrl
    },
    // 请求方法
    method() {
      return this.reqConfig.method || 'get'
    },
    // 请求参数
    params() {
      return this.reqConfig.params || {}
    },
    // 查询关键字
    keyword() {
      return this.reqConfig.keyword
    },
    // 查询内容
    searchValue() {
      return this.reqConfig.searchValue
    },
    // 数据格式
    dataFormat() {
      return this.reqConfig.dataFormat
    },
    // 当前grid配置
    curConfig() {
      // this.columnDefs.forEach(item => {
      //   if (!item.width) {
      //     item.width = 70
      //   }
      // })
      if (this.onlyShow) return this.columnDefs
      return this.defColumnDefs.concat(this.columnDefs)
    },
    // 单选/多选
    rowSelection() {
      // multiple / single
      return this.radio ? 'single' : 'multiple'
    }
  },
  watch: {
    visible(nv, ov) {
      if (nv) {
        // 获取初始分页配置
        this.tempInitparams = Format.deepClone(this.params)
        this.filterText = this.searchValue
        this.pagination = {
          pageNo: 0,
          pageSize: 10,
          total: 0
        }
        if (this.showPagination) {
          if (this.tempInitparams.pageNo > -1) {
            this.pagination[this.pageKey] = this.tempInitparams.pageNo
          }
          if (this.tempInitparams.pageSize > -1) {
            this.pagination[this.pageSizeKey] = this.tempInitparams.pageSize
          }
        }
        this.queryTableList()
      } else {
        this.filterText = ''
        this.rowData = []
      }
    }
  },
  created() {
    // 初始化ag-grid
    // this.tempInitparams = Format.deepClone(this.params)
    this.initGridOptions()
  },
  methods: {
    initGridOptions() {
      const _this = this
      const autoGroupColumnDef = {
        headerName: 'Athlete',
        field: 'id',
        width: 200,
        cellRenderer: 'agGroupCellRenderer',
        cellRendererParams: {
          checkbox: function(params) {
            return params.node.group === true
          }
        }
      }
      const gridOptions = {
        tooltipShowDelay: 0,
        suppressClipboardPaste: true,
        embedFullWidthRows: true,
        defaultColDef: {
          tooltipComponent: 'CubeAgGridTextTooltip',
          filter: true,
          sortable: true,
          resizable: true
        },
        rowSelection: this.rowSelection, // multiple / single
        rowMultiSelectWithClick: true,
        autoGroupColumnDef: autoGroupColumnDef,
        overlayLoadingTemplate: `<span class="ag-overlay-loading-center">${this.$t(
          'grid.others.dataLoading'
        )}...</span>`,
        overlayNoRowsTemplate: `<span class="ag-overlay-loading-center">${this.$t(
          'grid.others.noData'
        )}<span>`,
        suppressRowClickSelection: this.suppressRowClickSelection,
        enableRangeSelection: true,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit()
        },
        isRowSelectable: function(params) {
          let isDisable = false
          if (_this.disableSelected && _this.disableSelected.length) {
            _this.disableSelected.map((item) => {
              if (item === params.data[_this.disableSelectKey]) {
                isDisable = true
              }
            })
          }

          return !(_this.disableSelectKey && isDisable)
        },
        onRowDoubleClicked: (e) => {
          // 单选的情况下可以双击直接 = 确定
          if (this.rowSelection === 'single') {
            this.handleClose([e.data])
            this.selectedRightDataNodes = []
          }
        }
      }

      const cellRenderer = (params) => {
        return `<div class="ag-text-ellipsis">${params.value}</div>`
      }
      this.gridColumnDefs =
        this.curConfig?.map((item) => {
          if (!item.cellRendererFramework && !item.hideRender) {
            return {
              tooltipField: item.tooltipValueGetter ? '' : item.field,
              headerTooltip: item.headerName,
              cellRenderer,
              ...item
            }
          }

          return {
            tooltipField: item.tooltipValueGetter ? '' : item.field,
            headerTooltip: item.headerName,
            ...item
          }
        }) || []
      this.gridOptions = gridOptions
    },
    // 数据赋值
    assignData(rowData) {
      if (this.dataFormat) {
        if (this.dataFormat.key) {
          setTimeout(() => {
            this.gridOptions.api.setRowData(rowData.data[this.dataFormat.key])
          }, 300)
        } else {
          this.rowData = rowData.data
        }
        if (this.showPagination) {
          if (this.dataFormat.total) {
            this.pagination.total = rowData.data[this.dataFormat.total]
          } else {
            this.pagination.total = rowData.data.totalElements
          }
        }
      } else {
        this.rowData = rowData.data
        if (this.showPagination) {
          this.pagination.total = rowData.data.totalElements
        }
      }
    },
    // 格式化获取url
    formatUrl(params, url) {
      let urlStr = ''
      if (url.indexOf('{') > -1) {
        const urlArr = url.split('/')
        urlArr.forEach((item, index) => {
          if (index !== 0) {
            let temp
            if (item.indexOf('{') > -1) {
              temp = `/${params[item.substring(1, item.length - 1)]}`
            } else {
              temp = `/${item}`
            }
            urlStr += temp
          }
        })
      } else {
        urlStr = url
      }
      console.log('urlStr--', urlStr)
      // 需要将分页数据更新到路径上
      if (this.updataUrl) {
        urlStr = this.upDataUrl(urlStr)
      }
      return urlStr
    },
    // 获取列表
    queryTableList(search) {
      const params = {}
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.showLoadingOverlay()
      }
      // 有搜索框
      if (this.showSearch && this.keyword) {
        params[this.keyword] = this.filterText
      }
      // 有分页
      if (this.showPagination) {
        params[this.pageKey] = this.pagination[this.pageKey]
        params[this.pageSizeKey] = this.pagination[this.pageSizeKey]

        if (search) {
          // search时需要初始化分页
          params[this.pageKey] = this.tempInitparams.pageNo
          params[this.pageSizeKey] = this.tempInitparams.pageSize
          this.pagination[this.pageKey] = this.tempInitparams.pageNo
          this.pagination[this.pageSizeKey] = this.tempInitparams.pageSize
          this.$refs.pagination.resetPage(this.pagination[this.pageKey])
        }
      }
      const p = Format.deepClone(this.params)
      Object.assign(p, this.otherParams)
      Object.assign(p, params)
      const obj = { ...p }
      // 接口请求
      if (this.method.toLowerCase() === 'get') {
        request({
          url: this.formatUrl(obj, this.url),
          method: this.method,
          params: obj,
          noLoading: true
        })
          .then((rowData) => {
            this.assignData(rowData)
            this.$emit('afterFetch', rowData)
          })
          .catch((error) => {
            console.log('查询错误：', error)
            this.rowData = []
          })
      } else {
        request({
          url: this.formatUrl(obj, this.url),
          method: this.method,
          data: obj,
          noLoading: true
        })
          .then((rowData) => {
            console.log('rowData', rowData)
            this.assignData(rowData)
            this.$emit('afterFetch', rowData)
          })
          .catch((error) => {
            console.log('查询错误：', error)
            this.rowData = []
          })
      }
    },
    // 【右表】切换分页数据
    pageChange(obj) {
      this.pagination[this.pageKey] = obj.page
      this.pagination[this.pageSizeKey] = obj.limit
      // this.tempInitparams.pageNo = obj.page
      // this.tempInitparams.pageSize = obj.limit
      this.queryTableList()
    },
    // 分页数据更新到url路径上
    upDataUrl(v) {
      const p = this.pagination[this.pageKey]
      const ps = this.pagination[this.pageSizeKey]
      if ((!p && p !== 0) || (!ps && ps !== 0)) {
        return v
      }
      let urlArr = []
      let url = ''
      urlArr = v.split('/')
      urlArr.pop()
      urlArr.pop()
      url = urlArr.join('/')
      return `${url}/${p}/${ps}`
    },
    // 确定选择
    handleConfirm() {
      if (this.selectedRightDataNodes.length === 0) {
        MessageUtil.warning(this.$t('grid.tips.selectAtLeastOne'))
      } else {
        this.handleClose(this.selectedRightDataNodes, 'confirm')
        this.selectedRightDataNodes = []
      }
    },
    // 关闭/取消
    handleClose(value = [], type = 'close') {
      this.$emit('onSelect', value, type)
    },
    // 右表选择事件
    onSelectionChangedRightData() {
      if (this.customSelect) {
        this.$emit('selectChange', this.gridOptions.api)
        return
      }
      if (this.gridOptions && this.gridOptions.api) {
        const selectedNodes = this.gridOptions.api.getSelectedNodes()
        const selectedData = selectedNodes.map((node) => node.data)
        this.selectedRightDataNodes = selectedData
      }
    }
  }
}
</script>
